import config from '@/config/config';

import Index from '@/pages/config/document-type/index.vue';
import List from '@/pages/config/document-type/list/list.vue';
import View from '@/pages/config/document-type/view/view.vue';
import New from '@/pages/config/document-type/new/new.vue';
import Edit from '@/pages/config/document-type/edit/edit.vue';

const modulePermission = config.modules.documentType;

export default {
  path: '/document-type',
  name: 'document-type',
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: 'enabled_read',
  },
  children: [
    {
      path: 'list',
      name: 'document-type-list',
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
    },
    {
      path: ':id',
      name: 'document-type-view',
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
      props: true,
    },
    {
      path: 'new',
      name: 'document-type-new',
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_create',
      },
    },
    {
      path: ':id/e',
      name: 'document-type-edit',
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_edit',
      },
      props: true,
    },
  ],
};
